import { Injectable } from '@angular/core';
import { IDeviceNode } from '../models/device';
import * as _ from 'lodash';

@Injectable({
    providedIn: 'root',
})
export class DeviceNodeCleanupService {
    static $name = 'deviceNodeCleanupService';

    private static listOfElementsToRemove = [
        '$flatControlInputs',
        '$flatDynamicCalendars',
    ];

    cleanUpAndDeepCopy(deviceNode: IDeviceNode) {
        const dnCloned = _.cloneDeep(deviceNode);

        DeviceNodeCleanupService.listOfElementsToRemove.forEach(attributeName => {
            delete dnCloned[attributeName];
        })

        return dnCloned;
    }
}
